export default __webpack_public_path__ + "static/media/LogoReceiptPreview.219c6b9f.jpg";